<form [formGroup]="offerForm" class="radio-form" aria-labelledby="rdoBtns">
  <mat-radio-group
    aria-label="Select an option"
    class="radio-group"
    [ngClass]="{'radio-group--invalid': addItemToCartHasError()}"
    id="rdoBtns"
    role="radiogroup"
    aria-required="true"
    formControlName="addItemToCart"
    required="true">
    <mat-radio-button
      id="rdo_yes"
      [value]="true"
      class="radio-label"
      disableRipple="true">
      {{ yesRadioLabel }}
    </mat-radio-button>
    <mat-radio-button
      id="rdo_no"
      [value]="false"
      class="radio-label"
      disableRipple="true">
      {{ noRadioLabel }}
    </mat-radio-button>

    @if (offerForm.touched && offerForm.invalid) {
      <span
        class="radio-group-error-message form-control__error-message"
        #radioErrorMessage
        tabindex="-1">
        Choose an option to proceed.
      </span>
    }
  </mat-radio-group>

  @if (showMarketingOptIn && offerForm.get('marketingOptIn')) {
    <div class="marketing-opt-in">
      <se-fe-checkbox
        id="chk_marketing_opt_in"
        formControlName="marketingOptIn"
        [seFeDataOptions]="marketingCheckOptions"></se-fe-checkbox>
    </div>
  }

  <div class="disclaimer-display">
    <p
      class="disclaimer-display__label"
      [innerHTML]="
        serviceOffer.marketingDisclaimer ?? serviceOffer.disclaimer
      "></p>
    <p
      class="disclaimer-display__label"
      [innerHTML]="serviceOffer.quote?.displayOverrides?.disclaimer ?? ''"></p>
  </div>
</form>
